// Components, Layouts, Pages
import { DashboardPageTeacher, DiscussionPageTeacher, MaterialPageTeacher, StudentPageTeacher } from '~/pages/teacher';
import { IRouteModel } from '~/utils/interface/base';
// Others
// Styles, images, icons

export const teacherRoute = {
  base: '/teacher',

  // Common
  commonCreate: '/create',
  commonDetail: '/:id',

  students: '/students',
  materials: '/materials',
  course: '/course',
  quiz: '/quiz',
  discussions: '/discussions',
};

export const privateTeacherRoutes: IRouteModel[] = [
  {
    index: true,
    path: `${teacherRoute.base}`,
    component: DashboardPageTeacher,
    name: 'Dashboard',
  },
  {
    index: true,
    path: `${teacherRoute.base}${teacherRoute.students}`,
    component: StudentPageTeacher,
    name: 'Student',
  },
  {
    index: true,
    path: `${teacherRoute.base}${teacherRoute.materials}`,
    component: MaterialPageTeacher,
    name: 'Material',
  },
  {
    index: true,
    path: `${teacherRoute.base}${teacherRoute.discussions}`,
    component: DiscussionPageTeacher,
    name: 'Discussion',
  },
];

export const teacherRouteAbsolute = {
  dashboard: `${teacherRoute.base}`,
};
